module.exports = __webpack_public_path__ + "img/cargo-wagon-mask-2.6708cceb.png";